module.exports = __webpack_public_path__ + "static/img/fail-icon.9b8e93d1.png";